import { create } from 'zustand';

type KeyboardShortcutsDrawerStore = {
  isOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
  setOpen: (isOpen: boolean) => void;
};

export const useKeyboardShortcutsDrawerStore = create<KeyboardShortcutsDrawerStore>((set) => ({
  isOpen: false,
  openDrawer: () => set({ isOpen: true }),
  closeDrawer: () => set({ isOpen: false }),
  setOpen: (isOpen) => set({ isOpen }),
}));
